// prettier-ignore
export default {
    "DESCRIPTION": "Nous et des tiers utilisons des cookies \u00e0 des fins techniques, de mesure et de marketing. Gr\u00e2ce \u00e0 votre consentement, nous pourrons am\u00e9liorer l'exp\u00e9rience utilisateur, le refus pourrait rendre les fonctions relatives indisponibles.",
    "POLICY": "Contrat",
    "ACCEPT": "Accept",
    "REFUSE": "Refuse"
} as const